import {
  CREATE_SEARCH,
  FETCH_RECENT_SEARCHES,
  SET_RECENT_SEARCHES,
} from './actionConstants'
import uuidV4 from 'lib/string/uuidV4Utils'
import { AnyAppAction } from 'actions/types/ActionTypes'
import { deleteRecentSearch, getRecentSearches, saveRecentSearch } from 'components/Search/utils'
import { setFlightSessionRecentSearch } from 'lib/flights/flightUtils'
import { clearBusinessTravellerSelectedTraveller } from 'businessTraveller/storage/businessTravellerStorage'
import setSelectedBusinessTravellersAndGuests from './businessTraveller/setSelectedBusinessTravellerEmployeesAndGuests'
import { clearFlightSearchResult } from './FlightActions'
import { clearApprovalRequestId } from './CheckoutActions'
import { resetFlightsTimer, expireFlightsTimer } from 'components/Flights/FlightsSessionTimer/FlightsSessionTimer'

export function createSearch(
  action: { searchKey: string, searchId: string, searchContext?: App.SearchContext, searchEvent?: App.SearchEvent },
) {
  const { searchKey, searchId, searchContext, searchEvent } = action

  return {
    type: CREATE_SEARCH,
    key: searchKey,
    searchContext,
    searchEvent,
    searchId,
  }
}

export function setSearchSession(
  searchKey: string,
  options: { newSearchId?: string, searchContext?: App.SearchContext, searchEvent?: App.SearchEvent } = {},
): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()

    const { newSearchId, searchContext, searchEvent } = options

    const searchId = state.search.searches[searchKey]?.searchId ?? newSearchId ?? uuidV4()

    // Create/continue the search session in Redux
    dispatch(createSearch({ searchKey, searchId, searchContext, searchEvent }))

    // Reset the flights session timer for a fresh search session
    resetFlightsTimer()
  }
}

export function fetchRecentSearches(): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.auth.recentSearches.length > 0) {
      // already updated this, don't need to do it again
      // it should always be in sync after initial fetch
      return
    }

    const recentSearches = getRecentSearches(state.auth.account.memberId)

    dispatch({
      type: FETCH_RECENT_SEARCHES,
      data: recentSearches,
    })
  }
}

export function addRecentSearch(
  searchItem: App.SearchItem,
): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()

    saveRecentSearch(searchItem, state.auth.account.memberId)

    dispatch({
      type: SET_RECENT_SEARCHES,
      // our source of truth for recent search is local storage (for now?)
      // so once we save it, get the whole list
      data: getRecentSearches(state.auth.account.memberId),
    })
  }
}

export function removeRecentSearch(
  id: string,
): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()

    deleteRecentSearch(id, state.auth.account.memberId)

    dispatch({
      type: SET_RECENT_SEARCHES,
      // our source of truth for recent search is local storage (for now?)
      // so once we save it, get the whole list
      data: getRecentSearches(state.auth.account.memberId),
    })
  }
}

export function clearRecentSearches(): AnyAppAction {
  return (dispatch) => {
    dispatch({
      type: SET_RECENT_SEARCHES,
      data: [],
    })
  }
}

export function clearAllSearchState(): AnyAppAction {
  return (dispatch) => {
    // Immediately expire the flights session timer when clearing search state
    expireFlightsTimer()

    // Clear Redux state for recent searches
    dispatch(clearRecentSearches())

    // Clear flight search results and fare families cache
    dispatch(clearFlightSearchResult())

    // Clear localStorage flight session data
    setFlightSessionRecentSearch({
      flights: [],
    })

    // local storage
    clearBusinessTravellerSelectedTraveller()
    // redux
    dispatch(setSelectedBusinessTravellersAndGuests([], 0))

    // Clear any approval request in checkout state carried over from checkout
    dispatch(clearApprovalRequestId())
  }
}
